import React from "react";
import "./PipelinesPageUtil.css";
import { Table, Checkbox } from "rsuite";
import { apiGetRequest } from "../../api";

export const renderRowExpanded = (rowData) => {
  return (
    <div className="accordion-styles">
      {rowData.tables && rowData.tables.length > 0 ? (
        rowData.tables.map((table, index) => (
          <div key={table}>Table: {table}</div>
        ))
      ) : (
        <div>No tables found</div>
      )}
    </div>
  );
};

export const StatusCell = ({ rowData, dataKey, ...props }) => {
  let statusClassName = "status-bar";
  let statusText = rowData[dataKey];

  if (rowData && dataKey) {
    switch (rowData[dataKey]) {
      case true:
        statusClassName = "status-bar-running";
        statusText = "Running";
        break;
      case "Paused":
        statusClassName = "status-bar-paused";
        statusText = "Paused";
        break;
      case false:
        statusClassName = "status-bar-deleted";
        statusText = "Inactive";
        break;
      default:
        break;
    }
  }

  return (
    <Table.Cell {...props} style={{ padding: 0 }}>
      <div className={statusClassName}>{statusText}</div>
    </Table.Cell>
  );
};

export const DataCell = ({ rowData, dataKey, ...props }) => (
  <Table.Cell {...props} style={{ padding: 0 }}>
    <div>
      {" "}
      {/* eslint-disable-next-line */}
      <a role="link" aria-disabled="true" className="disabled" href="">
        data
      </a>
    </div>
  </Table.Cell>
);

export const DashboardCell = ({ rowData, dataKey, ...props }) => (
  <Table.Cell {...props} style={{ padding: 0 }}>
    <div>
      {" "}
      {/* eslint-disable-next-line */}
      <a role="link" aria-disabled="true" className="disabled" href="">
        dashboard
      </a>
    </div>
  </Table.Cell>
);

const Overlay = React.forwardRef(
  (
    {
      style,
      onClose,
      selectedDatasources,
      setSelectedDatasources,
      setFilterDatasource,
      distinctDatasources,
      ...rest
    },
    ref
  ) => {
    const handleCheckboxChange = (datasource) => {
      setSelectedDatasources((prevSelected) =>
        prevSelected.includes(datasource)
          ? prevSelected.filter((item) => item !== datasource)
          : [...prevSelected, datasource]
      );
    };

    const handleApply = () => {
      setFilterDatasource(selectedDatasources);
      onClose();
    };

    const handleClear = () => {
      setSelectedDatasources([]);
      setFilterDatasource([]);
      onClose();
    };

    const styles = {
      ...style,
      color: "#000",
      background: "#fff",
      width: 200,
      padding: 10,
      borderRadius: 4,
      position: "absolute",
      border: "1px solid #ddd",
      boxShadow: "0 3px 6px -2px rgba(0, 0, 0, 0.6)",
      marginTop: "1rem",
      display: "flex",
      flexDirection: "column",
      maxHeight: "300px",
    };

    const datasourceListStyle = {
      overflowY: "auto",
      flex: 1,
      marginBottom: "10px",
    };

    const buttonsContainerStyle = {
      display: "flex",
      justifyContent: "space-evenly",
    };

    return (
      <div {...rest} style={styles} ref={ref}>
        <div style={datasourceListStyle}>
          {distinctDatasources.map((datasource) => (
            <div
              key={datasource}
              style={{ fontSize: "12px", fontWeight: "500", height: "22px" }}
            >
              <Checkbox
                checked={selectedDatasources.includes(datasource)}
                onChange={() => handleCheckboxChange(datasource)}
              />
              {datasource}
            </div>
          ))}
        </div>
        <div style={buttonsContainerStyle}>
          <button onClick={handleApply} className="apply-button">
            Apply
          </button>
          <button onClick={handleClear} className="clear-button">
            Clear
          </button>
        </div>
      </div>
    );
  }
);

const OverlayComponent = React.forwardRef((props, ref) => {
  const {
    className,
    onClose,
    selectedDatasources,
    setSelectedDatasources,
    setFilterDatasource,
    distinctDatasources,
  } = props;
  return (
    <Overlay
      onClose={onClose}
      className={className}
      ref={ref}
      selectedDatasources={selectedDatasources}
      setSelectedDatasources={setSelectedDatasources}
      setFilterDatasource={setFilterDatasource}
      distinctDatasources={distinctDatasources}
    />
  );
});

export const renderOverlay = (
  props,
  ref,
  pipelines,
  selectedDatasources,
  setSelectedDatasources,
  setFilterDatasource
) => {
  const distinctDatasources = [
    ...new Set(pipelines.map((item) => item.datasource)),
  ];

  return (
    <OverlayComponent
      {...props}
      ref={ref}
      selectedDatasources={selectedDatasources}
      setSelectedDatasources={setSelectedDatasources}
      setFilterDatasource={setFilterDatasource}
      distinctDatasources={distinctDatasources}
    />
  );
};

export const fetchData = async (
  setPipelines,
  setTimeout,
  setLoading,
  setShowTable,
  setShowModal
) => {
  try {
    const data = await apiGetRequest("/pipelines-data-mongodb");
    setPipelines(data);
    setTimeout(() => {
      setLoading(false);
      setShowTable(true);
    }, 3000);
  } catch (error) {
    console.error("Error fetching pipelines:", error);
    setLoading(false);
    if (error.response && error.response.status === 401) {
      setShowTable(true);
      setShowModal(true);
    }
  }
};

export const getData = (
  limit,
  page,
  pipelines,
  searchQuery,
  filterDatasource
) => {
  const filteredData = getFilteredData(
    pipelines,
    searchQuery,
    filterDatasource
  );
  const start = limit * (page - 1);
  const end = start + limit;
  return filteredData.slice(start, end);
};

export const getFilteredData = (pipelines, searchQuery, filterDatasource) => {
  let filteredData = pipelines;

  // Filter data based on searchQuery
  if (searchQuery) {
    filteredData = pipelines.filter((item) =>
      Object.values(item).some((value) =>
        value.toString().toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }

  // Filter data based on filterDatasource
  if (filterDatasource.length > 0) {
    filteredData = filteredData.filter((item) =>
      filterDatasource.includes(item.datasource)
    );
  }

  return filteredData;
};

export const formatDate = (dateString) => {
  const options = { month: "long", day: "numeric", year: "numeric", timeZone: "UTC"};
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", options);
};

export const handleChangeLimit = (dataKey, setPage, setLimit) => {
  setPage(1);
  setLimit(dataKey);
};

export const handleExpanded = (
  rowData,
  rowKey,
  expandedRowKeys,
  setExpandedRowKeys
) => {
  let open = false;
  const nextExpandedRowKeys = [];

  expandedRowKeys.forEach((key) => {
    if (key === rowData[rowKey]) {
      open = true;
    } else {
      nextExpandedRowKeys.push(key);
    }
  });

  if (!open) {
    nextExpandedRowKeys.push(rowData[rowKey]);
  }

  setExpandedRowKeys(nextExpandedRowKeys);
};

export const handleRefresh = async (setPipelines, setLoading, setShowModal) => {
  try {
    setLoading(true);
    const newData = await apiGetRequest("/fetch-and-insert");
    setPipelines(newData);
    setLoading(false);
  } catch (error) {
    console.error("Error refreshing data:", error);
    setLoading(false);
    if (error.response && error.response.status === 401) {
      setShowModal(true);
    }
  }
};

export const handleSortColumn = (
  sortColumn,
  sortType,
  pipelines,
  setPipelines,
  setSortColumn,
  setSortType,
  setLoading
) => {
  setLoading(true);

  const sortedData = [...pipelines].sort((a, b) => {
    const valueA = a[sortColumn];
    const valueB = b[sortColumn];

    if (sortType === "asc") {
      return valueA > valueB ? 1 : -1;
    } else if (sortType === "desc") {
      return valueA < valueB ? 1 : -1;
    }
    return 0;
  });

  setTimeout(() => {
    setLoading(false);
    setPipelines(sortedData);
    setSortColumn(sortColumn);
    setSortType(sortType);
  }, 500);
};
